export default {
  matchDuration: 40,
  timeBetweenMatches: 5
};
